<template>
  <div class="modern-admin">
    <header-component />

    <div class="back-btn-container">
      <button class="back-btn" @click="$router.push('/adminpanel')">
        العودة للوحة التحكم
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
      </button>
    </div>

    <!-- Notification Section -->
    <div v-if="notification.message" class="notification-box">
      <div :class="['notification', notification.type]">
        {{ notification.message }}
      </div>
    </div>

    <div class="admin-container" dir="rtl">
      <div class="admin-header">
        <h1 class="page-title">إدارة المواعيد</h1>
        <p class="page-subtitle">سفارة معرفة مكتبة الإسكندرية - جامعة العلمين الدولية</p>
      </div>

      <!-- Toggle Buttons for Single or Bulk Add -->
      <div class="form-toggle">
        <button
          @click="showSingleForm = true"
          :class="['toggle-btn', { 'active': showSingleForm }]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          إضافة موعد جديد
        </button>
        <button
          @click="showSingleForm = false"
          :class="['toggle-btn', { 'active': !showSingleForm }]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          إضافة مواعيد بشكل جماعي
        </button>
      </div>

      <!-- Single Slot Form -->
      <div v-if="showSingleForm" class="admin-form">
        <h3 class="form-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          إضافة موعد جديد
        </h3>
        <div class="form-grid">
          <div class="form-group">
            <label for="date" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              التاريخ
            </label>
            <input
              v-model="newSlot.date"
              type="date"
              id="date"
              class="form-input"
              :min="minDate"
              required
            />
            <p v-if="newSlot.date" class="form-hint">
              {{ getDayName(newSlot.date) }}، {{ formatDate(newSlot.date) }}
            </p>
          </div>

          <div class="form-group">
            <label for="start_time" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              وقت البداية
            </label>
            <input 
              v-model="newSlot.start_time" 
              type="time" 
              id="start_time" 
              class="form-input" 
              required 
            />
          </div>

          <div class="form-group">
            <label for="end_time" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              وقت النهاية
            </label>
            <input 
              v-model="newSlot.end_time" 
              type="time" 
              id="end_time" 
              class="form-input" 
              required 
            />
          </div>

          <div class="form-group">
            <label for="max_devices" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              عدد الأجهزة
            </label>
            <input 
              v-model="newSlot.max_devices" 
              type="number" 
              id="max_devices" 
              class="form-input" 
              min="1" 
              max="99" 
              required 
            />
          </div>
        </div>
        
        <div class="form-actions">
          <button @click="addSlot" class="submit-btn">
            <span v-if="loading" class="spinner"></span>
            <span v-else>إضافة موعد</span>
          </button>
        </div>
      </div>

      <!-- Bulk Add Slots Form -->
      <div v-else class="admin-form">
        <h3 class="form-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          إضافة مواعيد بشكل جماعي
        </h3>
        
        <div class="form-grid">
          <div class="form-group">
            <label for="start_date" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              تاريخ البداية
            </label>
            <input
              v-model="bulkSlots.start_date"
              type="date"
              id="start_date"
              class="form-input"
              :min="minDate"
              required
            />
            <p v-if="bulkSlots.start_date" class="form-hint">
              {{ getDayName(bulkSlots.start_date) }}، {{ formatDate(bulkSlots.start_date) }}
            </p>
          </div>

          <div class="form-group">
            <label for="end_date" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              تاريخ النهاية
            </label>
            <input
              v-model="bulkSlots.end_date"
              type="date"
              id="end_date"
              class="form-input"
              :min="bulkSlots.start_date"
              required
            />
            <p v-if="bulkSlots.end_date" class="form-hint">
              {{ getDayName(bulkSlots.end_date) }}، {{ formatDate(bulkSlots.end_date) }}
            </p>
          </div>

          <div class="form-group">
            <label class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              اختر الأيام
            </label>
            <div class="day-checkboxes">
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="all" @change="toggleAllDays" />
                <span class="day-circle">الكل</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="0" />
                <span class="day-circle">الأحد</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="1" />
                <span class="day-circle">الاثنين</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="2" />
                <span class="day-circle">الثلاثاء</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="3" />
                <span class="day-circle">الأربعاء</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="4" />
                <span class="day-circle">الخميس</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="5" />
                <span class="day-circle">الجمعة</span>
              </label>
              <label class="day-checkbox">
                <input type="checkbox" v-model="bulkSlots.selectedDays" value="6" />
                <span class="day-circle">السبت</span>
              </label>
            </div>
          </div>

          <div class="form-group">
            <label for="bulk_start_time" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              وقت البداية
            </label>
            <input 
              v-model="bulkSlots.start_time" 
              type="time" 
              id="bulk_start_time" 
              class="form-input" 
              required 
            />
          </div>

          <div class="form-group">
            <label for="bulk_end_time" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              وقت النهاية
            </label>
            <input 
              v-model="bulkSlots.end_time" 
              type="time" 
              id="bulk_end_time" 
              class="form-input" 
              required 
            />
          </div>

          <div class="form-group">
            <label for="interval" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              الفاصل الزمني (دقائق)
            </label>
            <input 
              v-model="bulkSlots.interval" 
              type="number" 
              id="interval" 
              class="form-input" 
              min="15" 
              max="240" 
              step="15" 
              required 
            />
          </div>

          <div class="form-group">
            <label for="bulk_max_devices" class="form-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              عدد الأجهزة للموعد الواحد
            </label>
            <input 
              v-model="bulkSlots.max_devices" 
              type="number" 
              id="bulk_max_devices" 
              class="form-input" 
              min="1" 
              max="30" 
              required 
            />
          </div>
        </div>
        
        <div class="form-actions">
          <button @click="addBulkSlots" class="submit-btn">
            <span v-if="loading" class="spinner"></span>
            <span v-else>إضافة مواعيد</span>
          </button>
        </div>
      </div>

      <!-- Slots Management Section -->
      <div class="slots-section">
        <div class="section-header">
          <h3 class="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            المواعيد المتاحة
          </h3>
          
          <!-- Month Navigation -->
          <div class="month-navigation">
            <button @click="previousMonth" :disabled="!hasPreviousMonth" class="pagination-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline> 
              </svg>
            </button>
            
            <h4 class="current-month">{{ currentMonthName }} {{ currentYear }}</h4>
            
            <button @click="nextMonth" :disabled="!hasNextMonth" class="pagination-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
               <polyline points="15 18 9 12 15 6"></polyline> 
              </svg>
            </button>
            
            <button @click="goToCurrentMonth" class="today-btn">
              اليوم
            </button>
          </div>
        </div>

        <!-- Filters -->
        <div class="filters">
          <div class="filter-group">
            <label for="filter-day" class="filter-label">اليوم</label>
            <select v-model="filters.day" id="filter-day" class="filter-input">
              <option value="">كل الأيام</option>
              <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
            </select>
          </div>
          
          <div class="filter-group">
            <label for="filter-date" class="filter-label">التاريخ</label>
            <input
              v-model="filters.date"
              type="date"
              id="filter-date"
              class="filter-input"
            />
          </div>

          <div class="filter-group">
            <label for="filter-time" class="filter-label">الوقت</label>
            <input
              v-model="filters.time"
              type="time"
              id="filter-time"
              class="filter-input"
            />
          </div>
          
          <div class="filter-group">
            <label for="filter-status" class="filter-label">الحالة</label>
            <select v-model="filters.status" id="filter-status" class="filter-input">
              <option value="">كل الحالات</option>
              <option value="متاح">متاح</option>
              <option value="محجوز">محجوز</option>
              <option value="منتهي">منتهي</option>
            </select>
          </div>
          
          <button @click="resetFilters" class="reset-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="1 4 1 10 7 10"></polyline>
              <polyline points="23 20 23 14 17 14"></polyline>
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
            </svg>
            إعادة تعيين
          </button>
        </div>

  <!-- Bulk Actions -->
        <div class="bulk-actions" v-if="selectedSlots.length > 0">
          <button @click="toggleSelectAllMonthSlots" class="select-all-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 11 12 14 23 3"></polyline>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
            {{ selectedSlots.length === filteredSlots.length && filteredSlots.length > 0 ? 'إلغاء التحديد' : 'تحديد الكل' }}
          </button>
          <button @click="openBulkDeleteModal" class="delete-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
            حذف المحدد ({{ selectedSlots.length }})
          </button>
        </div>

        <div v-for="group in groupedSlots" :key="group.date" class="date-group">
          <div class="date-header" @click="toggleDayExpansion(group.date)">
            <input 
              type="checkbox" 
              :checked="isAllSlotsSelectedForDate(group.date)"
              @click.stop="toggleSelectAllDateSlots(group.date)"
            />
            <h4>
              {{ group.dayName }}، {{ group.formattedDate }}
              <span class="slot-count">{{ group.slots.length }} مواعيد</span>
            </h4>
            <span class="arrow-icon">{{ expandedDays.includes(group.date) ? '▼' : '◄' }}</span>
          </div>
          
          <table class="slots-table" v-if="expandedDays.includes(group.date)">
            <thead>
              <tr>
                <th class="select-col">
                  
                </th>
                <th class="time-col">وقت البداية</th>
                <th class="time-col">وقت النهاية</th>
                <th class="duration-col">المدة</th>
                <th class="status-col">الحالة</th>
                <th class="devices-col">الأجهزة</th>
                <th class="actions-col">الإجراءات</th>
              </tr>
            </thead>
            
            <tbody>
              <tr v-for="slot in group.slots" :key="slot._id" :class="{ 'selected-row': selectedSlots.includes(slot._id) }">
                <td class="select-col">
                  <input 
                    type="checkbox" 
                    v-model="selectedSlots" 
                    :value="slot._id" 
                    @change="updateTimeSlotSelection(group.date, slot.start_time)"
                  />
                </td>
                <td class="time-col">
                  <template v-if="editingSlotId === slot._id">
                    <input v-model="editingSlotData.start_time" type="time" class="edit-input">
                  </template>
                  <template v-else>
                    {{ formatTimeTo12H(slot.start_time) }}
                  </template>
                </td>
                <td class="time-col">
                  <template v-if="editingSlotId === slot._id">
                    <input v-model="editingSlotData.end_time" type="time" class="edit-input">
                  </template>
                  <template v-else>
                    {{ formatTimeTo12H(slot.end_time) }}
                  </template>
                </td>
                <td class="duration-col">{{ calculateDuration(slot.start_time, slot.end_time) }}</td>
                <td class="status-col">
                  <span :class="[
                    'status-badge',
                    { 
                      'available': slot.is_available && !isSlotPassed(slot),
                      'booked': !slot.is_available && !isSlotPassed(slot),
                      'expired': isSlotPassed(slot)
                    }
                  ]">
                    {{ isSlotPassed(slot) ? 'منتهي' : (slot.is_available ? 'متاح' : 'محجوز') }}
                  </span>
                </td>
                <td class="devices-col">
                  <template v-if="editingSlotId === slot._id">
                    <input 
                      v-model="editingSlotData.max_devices" 
                      type="number" 
                      min="1" 
                      max="99" 
                      class="edit-input"
                    >
                  </template>
                  <template v-else>
                    {{ slot.max_devices - slot.current_devices || 0 }}/{{ slot.max_devices || 0 }}
                    <span v-if="slot.current_devices < slot.max_devices" class="available-text">
                    </span>
                    <span v-else class="full-text">
                      (لا يوجد )
                    </span>
                  </template>
                </td>
                <td class="actions-col">
                  <template v-if="editingSlotId === slot._id">
                    <button @click="saveEditedSlot" class="save-btn">
                      <span v-if="loading" class="spinner"></span>
                      <span v-else>حفظ</span>
                    </button>
                    <button @click="cancelEditing" class="cancel-btn">إلغاء</button>
                  </template>
                  <template v-else>
                    <button @click="startEditing(slot)" class="edit-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                      تعديل
                    </button>
                    <button @click="openDeleteModal(slot._id)" class="delete-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                      حذف
                    </button>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div v-if="sortedSlots.length === 0" class="empty-row">
          <div class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <p>لا توجد مواعيد متاحة</p>
            <button @click="goToCurrentMonth" class="today-btn">
              عرض مواعيد الشهر الحالي
            </button>
          </div>
        </div>
      </div>

      <!-- Delete Confirmation Modal -->
      <div v-if="isDeleteModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              تأكيد الحذف
            </h3>
            <button @click="closeDeleteModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <p>هل أنت متأكد من حذف هذا الموعد؟</p>
            <div class="slot-details">
              <p><strong>التاريخ:</strong> {{ formatDate(editSlotData.date) }} ({{ getDayName(editSlotData.date) }})</p>
              <p><strong>الوقت:</strong> {{ formatTimeTo12H(editSlotData.start_time) }} - {{ formatTimeTo12H(editSlotData.end_time) }}</p>
              <p><strong>الأجهزة:</strong> {{ editSlotData.max_devices - editSlotData.current_devices || 0 }}/{{ editSlotData.max_devices || 0 }}</p>
            </div>
          </div>
          
          <div class="modal-footer">
            <button @click="closeDeleteModal" class="cancel-btn">إلغاء</button>
            <button @click="confirmDelete" class="delete-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>نعم، احذف</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Bulk Delete Confirmation Modal -->
      <div v-if="isBulkDeleteModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              تأكيد الحذف
            </h3>
            <button @click="closeBulkDeleteModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <p>هل أنت متأكد من حذف المواعيد المحددة؟</p>
            <p class="warning-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              سيتم حذف {{ selectedSlots.length }} مواعيد بشكل دائم
            </p>
          </div>
          
          <div class="modal-footer">
            <button @click="closeBulkDeleteModal" class="cancel-btn">إلغاء</button>
            <button @click="confirmBulkDelete" class="delete-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>نعم، احذف الكل</span>
            </button>
          </div>
        </div>
      </div>
    </div>
      
    <!-- Footer Component -->
    <footer-component />
  </div>
</template>

<script>
import axios from 'axios';
import HeaderComponent from '../../../public/global/headerComponent.vue';
import FooterComponent from '../../../public/global/footerComponent.vue';

export default {
  name: 'AdminSlots',
  components: { HeaderComponent, FooterComponent },
  data() {
    return {
      slots: [],
      newSlot: { date: '', start_time: '', end_time: '', max_devices: 20 },
      bulkSlots: {
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: '',
        interval: 60,
        max_devices: 20,
        selectedDays: []
      },
      filters: {
        date: '',
        day: '',
        time: '',
        status: '',
      },
      days: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      months: [
        "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
        "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
      ],
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      isDeleteModalOpen: false,
      isBulkDeleteModalOpen: false,
      editSlotData: {
        _id: '',
        date: '',
        start_time: '',
        end_time: '',
        is_available: true,
        max_devices: 20,
        current_devices: 0
      },
      slotToDelete: null,
      selectedSlots: [],
      selectAll: false,
      showSingleForm: true,
      notification: {
        message: '',
        type: '',
      },
      loading: false,
      editingSlotId: null,
      editingSlotData: {
        start_time: '',
        end_time: '',
        max_devices: 20
      },
      expandedDays: [],
      selectedDateTimes: {},
      selectAllTimeSlots: {}
    };
  },
  computed: {
    minDate() {
      return new Date().toISOString().split('T')[0];
    },
    currentMonthName() {
      return this.months[this.currentMonth];
    },
    hasPreviousMonth() {
      const now = new Date();
      const currentDate = new Date(this.currentYear, this.currentMonth, 1);
      return currentDate > new Date(now.getFullYear(), now.getMonth() - 3, 1);
    },
    hasNextMonth() {
      const now = new Date();
      const currentDate = new Date(this.currentYear, this.currentMonth, 1);
      return currentDate < new Date(now.getFullYear(), now.getMonth() + 12, 1);
    },
    filteredSlots() {
      return this.slots.filter(slot => {
        const slotDate = new Date(slot.date);
        const matchesMonthYear = (
          slotDate.getMonth() === this.currentMonth &&
          slotDate.getFullYear() === this.currentYear
        );
        const matchesFilters = (
          (!this.filters.date || this.formatDate(slot.date) === this.formatDate(this.filters.date)) &&
          (!this.filters.day || this.getDayName(slot.date) === this.filters.day) &&
          (!this.filters.time || slot.start_time === this.filters.time) &&
          (!this.filters.status || (this.isSlotPassed(slot) ? 'منتهي' : (slot.is_available ? 'متاح' : 'محجوز')) === this.filters.status)
        );
        return matchesMonthYear && matchesFilters;
      });
    },
    sortedSlots() {
      return this.filteredSlots.slice().sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        const timeA = a.start_time || "00:00";
        const timeB = b.start_time || "00:00";
        if (timeA < timeB) return -1;
        if (timeA > timeB) return 1;
        return 0;
      });
    },
    groupedSlots() {
      const groups = {};
      this.sortedSlots.forEach(slot => {
        const dateKey = slot.date;
        if (!groups[dateKey]) {
          groups[dateKey] = {
            date: slot.date,
            dayName: this.getDayName(slot.date),
            formattedDate: this.formatDate(slot.date),
            slots: []
          };
        }
        groups[dateKey].slots.push(slot);
      });
      return Object.values(groups).sort((a, b) => new Date(a.date) - new Date(b.date));
    }
  },
  methods: {
    toggleSelectAllMonthSlots() {
    if (this.selectedSlots.length === this.filteredSlots.length && this.filteredSlots.length > 0) {
      // If all slots are already selected, deselect all
      this.selectedSlots = [];
    } else {
      // Select all slots in the current filtered view
      this.selectedSlots = this.filteredSlots.map(slot => slot._id);
    }
  },
    formatTimeTo12H(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      let hours12 = parseInt(hours, 10) % 12 || 12;
      const ampm = parseInt(hours, 10) >= 12 ? 'م' : 'ص';
      return `${hours12}:${minutes} ${ampm}`;
    },
    getDayName(date) {
      return this.days[new Date(date).getDay()];
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    calculateDuration(startTime, endTime) {
      if (!startTime || !endTime) return 'غير متاح';
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      if (isNaN(start) || isNaN(end)) return 'غير متاح';
      if (end <= start) return 'غير متاح';
      const diff = end - start;
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      return `${hours} ساعة ${minutes} دقيقة`;
    },
    isSlotPassed(slot) {
      const now = new Date();
      const slotDate = new Date(slot.date);
      const slotStartTime = new Date(`${slot.date}T${slot.start_time}:00`);
      if (slotDate.toDateString() === now.toDateString()) {
        return now >= slotStartTime;
      }
      return slotDate < now;
    },
    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.loadSlotsForMonth();
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.loadSlotsForMonth();
    },
    goToCurrentMonth() {
      const now = new Date();
      this.currentMonth = now.getMonth();
      this.currentYear = now.getFullYear();
      this.loadSlotsForMonth();
    },
    resetFilters() {
      this.filters = {
        date: '',
        day: '',
        time: '',
        status: '',
      };
    },
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      setTimeout(() => {
        this.notification.message = '';
      }, 3000);
    },
    async loadSlotsForMonth() {
      try {
        const response = await axios.get('https://eok-aiu-backend.vercel.app/slots/list', {
          params: {
            month: this.currentMonth + 1,
            year: this.currentYear
          }
        });
        this.slots = response.data;
        this.expandedDays = [];
        this.selectedSlots = [];
      } catch (error) {
        console.error('Error loading slots:', error);
        this.showNotification('فشل تحميل المواعيد', 'error');
      }
    },
    async addSlot() {
      if (!this.newSlot.date || !this.newSlot.start_time || !this.newSlot.end_time || !this.newSlot.max_devices) {
        this.showNotification('الرجاء ملء جميع الحقول', 'error');
        return;
      }

      const duration = this.calculateDuration(this.newSlot.start_time, this.newSlot.end_time);
      if (!duration) {
        this.showNotification('وقت النهاية يجب أن يكون بعد وقت البداية', 'error');
        return;
      }

      this.loading = true;

      try {
        const response = await axios.post('https://eok-aiu-backend.vercel.app/slots/add', {
          date: this.newSlot.date,
          start_time: this.newSlot.start_time,
          end_time: this.newSlot.end_time,
          max_devices: this.newSlot.max_devices,
          is_available: true,
        });

        if (response.data?.slot) {
          this.slots.push(response.data.slot);
          this.newSlot = { date: '', start_time: '', end_time: '', max_devices: 20 };
          this.showNotification('تم إضافة الموعد بنجاح');
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Error adding slot:', error);
        const errorMsg = error.response?.data?.error || 'حدث خطأ في الخادم';
        this.showNotification(`فشل إضافة الموعد: ${errorMsg}`, 'error');
      } finally {
        this.loading = false;
      }
    },
    async addBulkSlots() {
      if (!this.bulkSlots.start_date || !this.bulkSlots.end_date || 
          !this.bulkSlots.start_time || !this.bulkSlots.end_time || 
          !this.bulkSlots.interval || this.bulkSlots.selectedDays.length === 0 || 
          !this.bulkSlots.max_devices) {
        this.showNotification('الرجاء ملء جميع الحقول وتحديد الأيام', 'error');
        return;
      }

      this.loading = true;
      const startDate = new Date(this.bulkSlots.start_date);
      const endDate = new Date(this.bulkSlots.end_date);
      const startTime = this.bulkSlots.start_time;
      const endTime = this.bulkSlots.end_time;
      const interval = parseInt(this.bulkSlots.interval);
      const selectedDays = this.bulkSlots.selectedDays.filter(day => day !== 'all');

      const slotsToAdd = [];

      for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
        const dayOfWeek = date.getDay().toString();
        
        if (selectedDays.includes(dayOfWeek)) {
          let currentTime = new Date(`1970-01-01T${startTime}:00`);
          const endTimeObj = new Date(`1970-01-01T${endTime}:00`);

          while (currentTime < endTimeObj) {
            const slotStartTime = currentTime.toTimeString().slice(0, 5);
            currentTime.setMinutes(currentTime.getMinutes() + interval);
            const slotEndTime = currentTime.toTimeString().slice(0, 5);

            if (currentTime <= endTimeObj) {
              slotsToAdd.push({
                date: date.toISOString().split('T')[0],
                start_time: slotStartTime,
                end_time: slotEndTime,
                max_devices: this.bulkSlots.max_devices,
                is_available: true,
              });
            }
          }
        }
      }

      try {
        const response = await axios.post('https://eok-aiu-backend.vercel.app/slots/bulk-add', {
          slots: slotsToAdd,
        });

        if (response.data?.slots) {
          this.slots.push(...response.data.slots);
          this.bulkSlots = { 
            start_date: '', 
            end_date: '', 
            start_time: '', 
            end_time: '', 
            interval: 60,
            max_devices: 20,
            selectedDays: [] 
          };
          this.showNotification(`تم إضافة ${response.data.slots.length} مواعيد بنجاح`);
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Error adding bulk slots:', error);
        const errorMsg = error.response?.data?.error || 'حدث خطأ في الخادم';
        this.showNotification(`فشل إضافة المواعيد: ${errorMsg}`, 'error');
      } finally {
        this.loading = false;
      }
    },
    openDeleteModal(slotId) {
      const slot = this.slots.find(s => s._id === slotId);
      if (slot) {
        this.editSlotData = { ...slot };
        this.slotToDelete = slotId;
        this.isDeleteModalOpen = true;
      }
    },
    closeDeleteModal() {
      this.isDeleteModalOpen = false;
      this.slotToDelete = null;
    },
    async confirmDelete() {
      if (this.slotToDelete) {
        this.loading = true;
        try {
          await axios.delete(`https://eok-aiu-backend.vercel.app/slots/${this.slotToDelete}`);
          this.slots = this.slots.filter(slot => slot._id !== this.slotToDelete);
          this.closeDeleteModal();
          this.showNotification('تم حذف الموعد بنجاح');
        } catch (error) {
          console.error('Error deleting slot:', error);
          this.showNotification('فشل حذف الموعد', 'error');
        } finally {
          this.loading = false;
        }
      }
    },
    startEditing(slot) {
      this.editingSlotId = slot._id;
      this.editingSlotData = {
        start_time: slot.start_time,
        end_time: slot.end_time,
        max_devices: slot.max_devices || 20
      };
    },
    cancelEditing() {
      this.editingSlotId = null;
      this.editingSlotData = {
        start_time: '',
        end_time: '',
        max_devices: 20
      };
    },
    async saveEditedSlot() {
      if (!this.editingSlotData.start_time || !this.editingSlotData.end_time || !this.editingSlotData.max_devices) {
        this.showNotification('الرجاء ملء جميع الحقول', 'error');
        return;
      }

      const originalSlot = this.slots.find(slot => slot._id === this.editingSlotId);
      
      if (!originalSlot) {
        this.showNotification('الموعد غير موجود', 'error');
        return;
      }

      this.loading = true;
      try {
        const response = await axios.put(
          `https://eok-aiu-backend.vercel.app/slots/${this.editingSlotId}`,
          {
            ...this.editingSlotData,
            date: originalSlot.date
          }
        );

        if (response.data?.updatedSlot) {
          this.slots = this.slots.map(slot =>
            slot._id === this.editingSlotId ? response.data.updatedSlot : slot
          );
          this.editingSlotId = null;
          this.showNotification('تم تعديل الموعد بنجاح');
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Error updating slot:', error);
        const errorMsg = error.response?.data?.error || 'حدث خطأ في الخادم';
        this.showNotification(`فشل التعديل: ${errorMsg}`, 'error');
      } finally {
        this.loading = false;
      }
    },
    toggleDayExpansion(date) {
      const index = this.expandedDays.indexOf(date);
      if (index === -1) {
        this.expandedDays.push(date);
      } else {
        this.expandedDays.splice(index, 1);
      }
    },
    isAllSlotsSelectedForDate(date) {
      const dateSlots = this.filteredSlots.filter(slot => slot.date === date);
      return dateSlots.length > 0 && dateSlots.every(slot => this.selectedSlots.includes(slot._id));
    },
    toggleSelectAllDateSlots(date) {
      const dateSlotIds = this.filteredSlots
        .filter(slot => slot.date === date)
        .map(slot => slot._id);
      
      const allSelected = dateSlotIds.every(id => 
        this.selectedSlots.includes(id)
      );
      
      if (allSelected) {
        this.selectedSlots = this.selectedSlots.filter(
          id => !dateSlotIds.includes(id)
        );
      } else {
        const newSelections = [...new Set([...this.selectedSlots, ...dateSlotIds])];
        this.selectedSlots = newSelections;
      }
    },
    isAllSlotsSelectedForTime(date, time) {
      if (!time) return false;
      const timeSlots = this.filteredSlots.filter(
        slot => slot.date === date && slot.start_time === time
      );
      return timeSlots.length > 0 && timeSlots.every(slot => this.selectedSlots.includes(slot._id));
    },
    toggleSelectAllTimeSlots(date, time) {
      if (!time) return;
      
      const timeSlotIds = this.filteredSlots
        .filter(slot => slot.date === date && slot.start_time === time)
        .map(slot => slot._id);
      
      const allSelected = timeSlotIds.every(id => 
        this.selectedSlots.includes(id)
      );
      
      if (allSelected) {
        this.selectedSlots = this.selectedSlots.filter(
          id => !timeSlotIds.includes(id)
        );
      } else {
        const newSelections = [...new Set([...this.selectedSlots, ...timeSlotIds])];
        this.selectedSlots = newSelections;
      }
    },
    updateTimeSlotSelection(date, time) {
      this.$nextTick(() => {
        const timeSlots = this.filteredSlots.filter(
          slot => slot.date === date && slot.start_time === time
        );
        
        const allSelected = timeSlots.every(slot => 
          this.selectedSlots.includes(slot._id)
        );
        
        this.$set(this.selectAllTimeSlots, `${date}-${time}`, allSelected);
      });
    },
    toggleAllDays(e) {
      if (e.target.checked) {
        this.bulkSlots.selectedDays = ['all', '0', '1', '2', '3', '4', '5', '6'];
      } else {
        this.bulkSlots.selectedDays = [];
      }
    },
    openBulkDeleteModal() {
      if (this.selectedSlots.length === 0) {
        this.showNotification('الرجاء تحديد مواعيد للحذف', 'error');
        return;
      }
      this.isBulkDeleteModalOpen = true;
    },
    closeBulkDeleteModal() {
      this.isBulkDeleteModalOpen = false;
    },
    async confirmBulkDelete() {
      if (this.selectedSlots.length === 0) return;
      
      this.loading = true;
      try {
        await axios.post('https://eok-aiu-backend.vercel.app/slots/bulk-delete', {
          slotIds: this.selectedSlots,
        });
        this.slots = this.slots.filter(slot => !this.selectedSlots.includes(slot._id));
        this.selectedSlots = [];
        this.closeBulkDeleteModal();
        this.showNotification(`تم حذف ${this.selectedSlots.length} مواعيد بنجاح`);
      } catch (error) {
        console.error('Error deleting bulk slots:', error);
        this.showNotification('فشل حذف المواعيد المحددة', 'error');
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.loadSlotsForMonth();
  },
  watch: {
    selectedSlots(newVal) {
      this.selectAll = newVal.length === this.filteredSlots.length && this.filteredSlots.length > 0;
    }
  }
};
</script>

<style scoped>
/* Modern Admin Styles */
.modern-admin {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.admin-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  flex: 1;
}

/* Header Styles */
.admin-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e1e4e8;
}

.page-title {
  font-size: 2rem;
  color: #0f106c;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.page-subtitle {
  font-size: 1.1rem;
  color: #666;
}

/* Form Toggle Styles */
.form-toggle {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.toggle-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  background-color: #f1f3f5;
  color: #555;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggle-btn.active {
  background-color: #0f106c;
  color: white;
}

.toggle-btn:hover:not(.active) {
  background-color: #e1e4e8;
}

/* Form Styles */
.admin-form {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.form-title {
  font-size: 1.25rem;
  color: #0f106c;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-title svg {
  color: #0f106c;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-label svg {
  color: #666;
}

.form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #0f106c;
  box-shadow: 0 0 0 3px rgba(15, 16, 108, 0.1);
}

.form-hint {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  padding: 0.75rem 1.5rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.submit-btn:hover:not(:disabled) {
  background-color: #0c0d5a;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Day Checkboxes */
.day-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.day-checkbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.day-checkbox input {
  display: none;
}

.day-circle {
  display: inline-block;
  width: 70px;
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #f1f3f5;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #ddd;
}

.day-checkbox input:checked + .day-circle {
  background-color: #0f106c;
  color: white;
  border-color: #0f106c;
}

/* Slots Section */
.slots-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.section-title {
  font-size: 1.25rem;
  color: #0f106c;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title svg {
  color: #0f106c;
}

.month-navigation {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.current-month {
  margin: 0 -0.5rem;
  font-size: 1.3rem;
  color: #0f106c;
  font-weight: 600;
  min-width: 180px;
  text-align: center;
}

.pagination-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  font-weight: 500;
}

.pagination-button:hover:not(:disabled) {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pagination-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.today-btn {
  padding: 0.5rem 1rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.today-btn:hover {
  background-color: #0c0d5a;
}

/* Bulk Actions */
.bulk-actions {
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.select-all-btn {
  padding: 0.5rem 1rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.select-all-btn:hover {
  background-color: #0c0d5a;
}

.delete-btn {
  padding: 0.5rem 1rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.delete-btn:hover {
  background-color: #c82333;
}

/* Filters */
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.filter-group {
  flex: 1;
  min-width: 150px;
}

.filter-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #555;
}

.filter-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
}

.reset-btn {
  padding: 0.5rem 1rem;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  align-self: flex-end;
}

.reset-btn:hover {
  background-color: #5a6268;
}

/* Grouped Slots Styles */
.date-group {
  margin-bottom: 2rem;
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  overflow: hidden;
}

.date-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e4e8;
  cursor: pointer;
  gap: 0.5rem;
}

.date-header h4 {
  margin: 0;
  color: #0f106c;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-grow: 1;
}

.slot-count {
  background-color: #0f106c;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
}

.arrow-icon {
  margin-left: 0.5rem;
  font-size: 1rem;
  transition: transform 0.3s;
}

/* Table Styles */
.slots-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.slots-table th {
  background-color: #f1f3f5;
  color: #333;
  padding: 0.75rem;
  text-align: right;
  font-weight: 500;
}

.slots-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
  text-align: right;
}

.slots-table tr:last-child td {
  border-bottom: none;
}

.slots-table tr:hover {
  background-color: #f8f9fa;
}

.selected-row {
  background-color: #e6f7ff !important;
}

/* Column Widths */
.select-col {
  width: 40px;
  text-align: center;
}

.time-col {
  min-width: 100px;
}

.duration-col {
  min-width: 120px;
}

.status-col {
  min-width: 120px;
}

.devices-col {
  min-width: 120px;
}

.actions-col {
  min-width: 150px;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-badge.available {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.booked {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.expired {
  background-color: #fff3cd;
  color: #856404;
}

/* Device Status */
.available-text {
  color: #28a745;
  font-size: 0.8rem;
}

.full-text {
  color: #dc3545;
  font-size: 0.8rem;
}

/* Action Buttons */
.edit-btn, .delete-btn, .save-btn, .cancel-btn {
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.5rem;
}

.edit-btn {
  background-color: #ffc107;
  color: #212529;
}

.edit-btn:hover {
  background-color: #e0a800;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

.save-btn {
  background-color: #28a745;
  color: white;
}

.save-btn:hover {
  background-color: #218838;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
}

.cancel-btn:hover {
  background-color: #5a6268;
}

/* Empty State */
.empty-row td {
  padding: 2rem;
  text-align: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #666;
}

.empty-state svg {
  color: #999;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  color: #0f106c;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-title svg {
  color: #0f106c;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #f1f3f5;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #eee;
}

.modal-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.modal-cancel-btn {
  background-color: #f1f3f5;
  color: #333;
}

.modal-cancel-btn:hover {
  background-color: #e1e4e8;
}

.modal-confirm-btn {
  background-color: #0f106c;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-confirm-btn:hover:not(:disabled) {
  background-color: #0c0d5a;
}

.modal-delete-btn {
  background-color: #dc3545;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-delete-btn:hover:not(:disabled) {
  background-color: #c82333;
}

.slot-details {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.slot-details p {
  margin: 0.5rem 0;
}

.warning-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc3545;
  margin-top: 1rem;
  font-weight: 500;
}

.warning-text svg {
  color: #dc3545;
}

/* Spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Notification */
.notification-box {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1100;
}

.notification {
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.5s, fadeOut 0.5s 2.5s forwards;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification.success {
  background-color: #28a745;
}

.notification.error {
  background-color: #dc3545;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
}

/* In-place editing styles */
.edit-input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 120px;
}

.slot-info p {
  margin: 0.5rem 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .month-navigation {
    width: 100%;
    justify-content: space-between;
  }
  
  .filters {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .filter-group {
    min-width: 100%;
  }
  
  .slots-table {
    font-size: 0.8rem;
  }
  
  .slots-table th, 
  .slots-table td {
    padding: 0.5rem;
  }
  
  .edit-btn, 
  .delete-btn {
    padding: 0.4rem 0.6rem;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .admin-container {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .form-toggle {
    flex-direction: column;
    width: 100%;
  }
  
  .toggle-btn {
    width: 100%;
    justify-content: center;
  }
  
  .modal-container {
    max-height: 80vh;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .modal-btn {
    width: 100%;
    justify-content: center;
  }

  .edit-input {
    max-width: 80px;
  }
  
  .day-circle {
    width: 60px;
    padding: 0.4rem;
    font-size: 0.8rem;
  }
}

.back-btn-container {
  margin: 1.5rem 0 0 0;
  display: flex;
  justify-content: flex-end;
}
.back-btn {
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}
.back-btn:hover {
  background-color: #23248c;
  box-shadow: 0 2px 8px rgba(15, 16, 108, 0.15);
}
</style>